module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iXRpe"))).then(() => parcelRequire('d0iPb'));